// Couldn't properly type this function right now so opted for non-strict version of it.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const excludeProps: (props: string[]) => any =
    (props) => (prop: string, defaultValidatorFn: (prop: string) => boolean) =>
        !props.includes(prop) && defaultValidatorFn(prop);

export default excludeProps;
